import React, { Fragment } from 'react';
import { Dropdown, Menu, Popconfirm, Button } from 'antd';
import classNames from 'classnames';
import { MoreOutlined, PlusOutlined, EditOutlined, DeleteOutlined, CopyOutlined } from "@ant-design/icons";


const DefaultActionByName = {
  add: (modelActions) => ({
    title: 'Добавить',
    icon: <PlusOutlined/>,
    action: () => modelActions.showEditForm({ show: true }),
  }),
  edit: (modelActions, item) => ({
    title: 'Редактировать',
    icon: <EditOutlined/>,
    action: () => modelActions.showEditForm({ show: true, object: item }),
  }),
  copy: (modelActions, item) => ({
    title: 'Копировать',
    icon: <CopyOutlined/>,
    action: () => {
      const { id, ...otherFields } = item;
      modelActions.showEditForm({ show: true, object: otherFields })
    },
  }),
  delete: (modelActions, item) => ({
    title: 'Удалить',
    icon: <DeleteOutlined/>,
    action: () => modelActions.delete(item),
    confirm: {
      title: 'Уверены, что хотите удалить?',
      okText: 'Удалить',
      cancelText: 'Отмена'
    }
  }),
};

const getActions = (actionName, actionByName) => {
  return Object.assign(DefaultActionByName, actionByName || {})[actionName];
}

const ActionButton = ({ className, modelActions, actions, buttonActions, actionByName, detail }) => {
  const cx = classNames([
    'action-button',
    className
  ]);

  const _actions = actions || [];
  const _buttonActions = buttonActions || [];

  const menu = (
    <Menu>
      {_actions.map((item, index) => {
        const action = getActions(item.name, actionByName);
        if (!action) return null;
        const itemAction = action(modelActions, detail);
        const title = item.title || itemAction.title || '';

        return (
          <Menu.Item key={`item${index}`} onClick={!itemAction.confirm && itemAction.action}>
            {itemAction.confirm ?
              <Popconfirm
                placement="bottomRight"
                title={itemAction.confirm.title}
                okText={itemAction.confirm.okText}
                cancelText={itemAction.confirm.cancelText}
                onConfirm={itemAction.action}
                onClick={e => e.stopPropagation()}
                getPopupContainer={trigger => trigger.parentNode}
              >
                {itemAction.icon}{title}
              </Popconfirm>
              :
              <Fragment>
                {itemAction.icon}{title}
              </Fragment>
            }
          </Menu.Item>
        )
      })}
    </Menu>
  );

  return (
    <div className={cx} >
      {_buttonActions.map((item, index) => {
        const action = getActions(item.name, actionByName);
        if (!action) return null;
        const itemAction = action(modelActions, detail);
        const title = item.title || itemAction.title || '';
        return (
          <Button 
            key={`btn${index}`} 
            className="action-button-btn" 
            type={item.type || 'default'} 
            size={item.size || 'default'}
            onClick={!itemAction.confirm && itemAction.action}
          >
            {itemAction.icon}{title}
          </Button>
        )
      })}

      <Dropdown className="action-button-dropdown" overlay={menu} trigger={['click']}>
        <MoreOutlined/>
      </Dropdown>
    </div>
  );
};

ActionButton.getActions = getActions;

export default ActionButton;
